import get from 'lodash/get';

import { productRequest, productResponse } from '@hero/schemas';
import categoryResponseSchema from '@hero/schemas/categoryResponseSchema';
import { getArrayChunks, morphism } from '@hero/utils';

import { api } from './api';
import { endpoints } from './endpoints';

const CHUNK_SIZE = 20;

async function getProductDetail(productId) {
  return api.get(endpoints.productDetail(productId)).then(res => {
    return morphism(productResponse.productDetail, res?.data?.data);
  });
}

async function getProductVariants(skus) {
  return api.post(endpoints.productVariants(), { skus }).then(res => {
    return morphism(productResponse.productVariants, res?.data?.data);
  });
}

async function searchProducts(params, signal) {
  return api
    .post(endpoints.productSearch(), morphism(productRequest.productList, params), {
      signal
    })
    .then(res => {
      return morphism(productResponse.searchProducts, res?.data?.data);
    });
}
const createProduct = payload =>
  api.post(endpoints.createProduct(), payload).then(res => {
    return morphism(productResponse.productDetail, res?.data?.data);
  });

const getCategories = params =>
  api.get(endpoints.categoryList(), { params }).then(res => {
    return morphism(categoryResponseSchema.listCategory, res?.data);
  });

const getProductsByChunks = async params => {
  const chunks = getArrayChunks(params?.filters?.merchantProductIds, CHUNK_SIZE);

  const promises = chunks.map(chunk => {
    return searchProducts({
      ...params,
      filters: {
        ...params.filters,
        merchantProductIds: chunk
      }
    });
  });

  const responses = await Promise.all(promises);
  return responses.reduce(
    (total, response) => {
      return {
        docs: [...total.docs, ...response.docs],
        pagination: response.pagination
      };
    },
    { docs: [] }
  );
};

const getTags = params =>
  api.get(endpoints.productTagList(), { params }).then(res => {
    const { tags } = morphism(productResponse.listTag, get(res, 'data'));
    return tags;
  });

const updateProduct = (id, payload) =>
  api.put(endpoints.productDetail(id), { ...payload }).then(res => {
    return morphism(productResponse.productDetail, res?.data?.data);
  });

export {
  createProduct,
  getCategories,
  getProductDetail,
  getProductVariants,
  getProductsByChunks,
  getTags,
  searchProducts,
  updateProduct
};
